"use strict";
/** state: Final **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var keycode = require("keycode");
/**
 * Promises are not supported in IE11
 * Therefore a promise polyfill is required to support that browser.
 */
require("promise-polyfill/dist/polyfill");
var React = require("react");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var icon_types_1 = require("../../types/icon.types");
var constants_1 = require("../constants");
var Dropdown_1 = require("../Dropdown");
var DropdownItem_1 = require("../DropdownItem");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var Input_1 = require("../Input");
var InputGroup_1 = require("../InputGroup");
var CLASS_NAME = 'i-autocomplete';
/**
 * AutoComplete controls allow for our users to search a large result set.
 * Results filter down as the user types.
 *
 * The results return all instances of the search text,
 * even if the text doesn't appear at the beginning.
 * This helps when users may not know the exact or format of text.
 * The user can to enter case-insensitive text.
 *
 * If the result set is less than 20 options, then use a dropdown control.
 */
var AutoComplete = /** @class */ (function (_super) {
    __extends(AutoComplete, _super);
    function AutoComplete(props) {
        var _this = _super.call(this, props) || this;
        _this.getMaxItems = function (items) {
            if (items === void 0) { items = []; }
            return _this.props.maxItems > 0 && items && items.length
                ? items.slice(_this.props.maxItems * -1)
                : items || [];
        };
        _this.handleKeyDown = function (e) {
            if (e.keyCode === keycode.codes.esc) {
                _this.handleClear();
                e.preventDefault();
            }
            if (e.keyCode === keycode.codes.tab) {
                _this.handleBlur(e);
            }
        };
        _this.handleSelect = function (e, selectedItem) {
            _this.props.onSelect(e, selectedItem);
            _this.inputRef.focus();
            _this.setState({
                isOpen: false,
                value: selectedItem.value,
            }, function () {
                _this.handleBlur(e);
            });
        };
        // this handler is called when someone closes the dropdown without selecting an item,
        // either through clicking outside the component or tabbing out.
        _this.handleBlur = function (e) {
            _this.setState({ isOpen: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(e);
            }
        };
        // when the user clicks out of the autocomplete before
        // the dropdown opens the dropdown onOutsideClick is bypassed
        // By checking the isLoading state we can account for this
        // we want to handle blurring at this point before the dropdown opens
        // and *also* after it closes.
        _this.handleDivBlur = function (e) {
            if (_this.state.isLoading || !_this.state.isOpen) {
                _this.setState({ isLoading: false });
                _this.handleBlur(e);
            }
        };
        _this.handleChange = function (e) {
            var value = e.target.value;
            if (value) {
                _this.changeSubject.next(value);
                _this.setState({
                    isLoading: !!value,
                    isOpen: !!value,
                    items: null,
                    value: value,
                });
            }
            else {
                _this.clear();
            }
        };
        _this.handleClear = function () {
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
            _this.clear();
        };
        _this.clear = function () {
            var value = '';
            _this.changeSubject.next(value);
            _this.setState({
                isLoading: false,
                isOpen: false,
                value: value,
            }, function () {
                if (_this.props.onClear) {
                    _this.props.onClear();
                }
            });
        };
        _this.state = {
            isLoading: false,
            isOpen: false,
            items: null,
            value: '',
        };
        return _this;
    }
    AutoComplete.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.value !== this.state.value) {
            this.setState({
                value: this.props.value,
            });
        }
        this.changeSubject = new rxjs_1.Subject();
        this.changeSubscription = this.changeSubject
            .pipe(operators_1.debounceTime(this.props.debounce), operators_1.distinctUntilChanged(), operators_1.switchMap(function (value) { return rxjs_1.from(_this.props.onInputChange(value)); }))
            .subscribe(function (items) {
            _this.setState({
                isLoading: false,
                items: _this.getMaxItems(items),
            });
        });
    };
    AutoComplete.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState({
                value: nextProps.value,
            });
        }
    };
    AutoComplete.prototype.componentDidUpdate = function (_, prevState) {
        if (prevState.isOpen && !this.state.isOpen) {
            // Update `state.value` if `props.value` is set,
            // or optimistic update if `state.value` has just been set.
            var value = this.props.value ||
                (this.state.value && this.state.value !== prevState.value
                    ? this.state.value
                    : null);
            if (value) {
                this.setState({ value: value });
            }
            else {
                this.clear();
            }
        }
    };
    AutoComplete.prototype.componentWillUnmount = function () {
        this.changeSubscription.unsubscribe();
    };
    AutoComplete.prototype.render = function () {
        var _this = this;
        var _a = this.props, addonAppended = _a.addonAppended, addonPrepended = _a.addonPrepended, className = _a.className, clearLabel = _a.clearLabel, debounce = _a.debounce, disabled = _a.disabled, id = _a.id, maxItems = _a.maxItems, noContentMessage = _a.noContentMessage, onBlur = _a.onBlur, onClear = _a.onClear, onFocus = _a.onFocus, onInputChange = _a.onInputChange, onSelect = _a.onSelect, placeholder = _a.placeholder, scrollHeight = _a.scrollHeight, value = _a.value, restProps = __rest(_a, ["addonAppended", "addonPrepended", "className", "clearLabel", "debounce", "disabled", "id", "maxItems", "noContentMessage", "onBlur", "onClear", "onFocus", "onInputChange", "onSelect", "placeholder", "scrollHeight", "value"]);
        var dropdownItems;
        if (this.state && this.state.items) {
            if (this.state.items.length) {
                var items = this.state.items;
                dropdownItems = items.map(function (item, index) {
                    if (item.display) {
                        var _a = item.display.props, onClick_1 = _a.onClick, children = _a.children, restItemProps = __rest(_a, ["onClick", "children"]);
                        return (React.createElement(DropdownItem_1.DropdownItem, __assign({ key: index, onClick: function (e) {
                                _this.handleSelect(e, item);
                                if (onClick_1) {
                                    onClick_1(e);
                                }
                            } }, restItemProps), children));
                    }
                    else {
                        return (React.createElement(DropdownItem_1.DropdownItem, { key: index, onClick: function (e) {
                                _this.handleSelect(e, item);
                            } }, item.value));
                    }
                });
            }
            else {
                dropdownItems = React.createElement(DropdownItem_1.DropdownItem, null, noContentMessage);
            }
        }
        return (React.createElement("div", __assign({ id: id + "__wrapper", className: classNames(CLASS_NAME, className), onKeyDown: this.handleKeyDown, onBlur: this.handleDivBlur }, restProps),
            React.createElement(Dropdown_1.Dropdown, { id: id + "__dropdown", role: Dropdown_1.Dropdown.Role.ListBox, isOpen: !this.state.isLoading && this.state.isOpen, onOutsideClick: this.handleBlur, onClose: function () {
                    if (_this.inputRef) {
                        _this.inputRef.focus();
                    }
                }, style: {
                    maxHeight: scrollHeight ? scrollHeight : 'auto',
                }, toggle: React.createElement(InputGroup_1.InputGroup, { clearable: !this.state.isLoading && clearLabel, disabled: disabled, onClear: this.handleClear },
                    addonPrepended && (React.createElement(InputGroup_1.InputGroup.Addon, { watermark: true }, addonPrepended)),
                    React.createElement(Input_1.Input, { id: id, placeholder: this.props.placeholder, value: this.state.value || '', onChange: this.handleChange, onFocus: onFocus, inputRef: function (el) { return (_this.inputRef = el); }, autoComplete: "off" }),
                    React.createElement(InputGroup_1.InputGroup.Addon, { watermark: true }, this.state.isLoading ? (React.createElement(IconWrapper_1.IconWrapper, null,
                        React.createElement(FontAwesome_1.FontAwesome, { name: icon_types_1.Icon.Loading, spin: true }))) : (addonAppended))) }, !this.state.isLoading && dropdownItems)));
    };
    AutoComplete.defaultProps = {
        addonAppended: (React.createElement(IconWrapper_1.IconWrapper, null,
            React.createElement(FontAwesome_1.FontAwesome, { name: icon_types_1.Icon.Search }))),
        debounce: constants_1.DEFAULT_DEBOUNCE_TIME,
        maxItems: -1,
    };
    return AutoComplete;
}(React.Component));
exports.AutoComplete = AutoComplete;
//# sourceMappingURL=AutoComplete.js.map